var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('router-link',{staticClass:"breadcrumb__link",attrs:{"to":{ name: _vm.indexPage }}},[_vm._v(" "+_vm._s(_vm.$t('GENERAL.HOME_PAGE'))+" ")]),_vm._v(" > "+_vm._s(_vm.pageName)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }